exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.v-btn[data-v-772f7532] {\n  color: #fff;\n}\nsvg.logo[data-v-772f7532] {\n  max-width: 216px;\n  height: 100%;\n}\n.logo-link[data-v-772f7532] {\n  font-size: 26px;\n  font-weight: 700;\n}\n.menu-icon[data-v-772f7532] {\n  width: 24px;\n  height: 24px;\n}", ""]);

// exports
